"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
/**
 * A React Hook that returns an AbortSignal that is marked as aborted when the calling component is
 * unmounted. This is useful for canceling promises, such as those for network requests, when a
 * component is unmounted.
 */
function useUnmountSignal() {
    const [abortController] = react_1.useState(() => new AbortController());
    react_1.useEffect(() => {
        return () => {
            abortController.abort();
        };
    }, []);
    return abortController.signal;
}
exports.default = useUnmountSignal;
//# sourceMappingURL=use-unmount-signal.js.map